import React from "react";

function InputField({ type, id, placeholder, value, onChange, maxLength,pattern }) {
  
  return (
    <input
      required
      type={type}
      id={id}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      pattern={pattern}
      className="w-full bg-tranparent py-[7px] px-6 rounded-full bg-syren-500 placeholder-white placeholder-opacity-50 text-[22px] font-bold border-2 border-white focus:outline-none"
    />
  );
}

export default InputField;
